import React from "react";
import "./App.css";
import TopBar from "./components/TopBar";
import Home from "./components/Home/Home";
import Employer from "./components/Employer/EmployerPage";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Footer from "./components/Footer";
import MSAProgramme from "./components/MSAProgramme/MSAProgramme";
import PageNotFound from "./components/NotFound";
import Faq from "./components/Faq/Faq";

function App() {
  return (
    <div className="App">
      <Router>
        <TopBar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/MSAProgramme" element={<MSAProgramme />} />
          {/*<Route path="/XPChallenge" element={<XPChallenge />} />*/}
          <Route path="/Employers" element={<Employer />} />
          <Route path="/Faq" element={<Faq />} />
          <Route path="/" element={<PageNotFound />} />
        </Routes>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
